/*
 * @Author: ylq
 * @Date: 2023-06-19 16:01:11
 * @Desc: 商机
 * @Last Modified by: ylq
 * @Last Modified time: 2023-09-19 17:55:41
 */

const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');
const DEFAULT_PAGE = () => import('@/layout/page.vue');

const OPPORTUNITY = {
  path: '/opportunity',
  name: 'opportunity',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'opportunity-list' },
  meta: {
    title: '商机',
    requiresAuth: true,
    hideChildrenInMenu: true,
    roles: 'businessOpportunity',
    order: 3
  },
  children: [
    {
      path: 'index',
      name: 'opportunity-list-wrap',
      component: DEFAULT_PAGE,
      redirect: { name: 'opportunity-list' },
      meta: {
        hideChildrenInMenu: true,
        requiresAuth: true,
        roles: 'businessOpportunity',
        title: '商机管理'
      },
      children: [
        {
          path: '',
          name: 'opportunity-list',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 3 },
          meta: {
            requiresAuth: true,
            title: '商机管理',
            roles: 'businessOpportunity:view'
          }
        },
        {
          path: ':id/collaborators',
          name: 'opportunity-index-detail-collaborators',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 3 },
          meta: {
            requiresAuth: true,
            title: '商机管理详情',
            roles: 'businessOpportunity:view'
          }
        },
        {
          path: ':id',
          name: 'opportunity-index-detail',
          component: () => import('@/views/sys-obj/sys-obj.vue'),
          props: { entity: 3 },
          meta: {
            requiresAuth: true,
            title: '商机管理详情',
            roles: 'businessOpportunity:view'
          }
        }
      ]
    }
  ]
};

export default OPPORTUNITY;
